import React from 'react';
import { Menu, Modal } from 'antd';
import {
  useCanAddDesk,
  useHasDeskNames,
} from '../../../controllers/DesksDataTracker';
import { useAddDeskToAcceptanceSetup } from '../../../controllers/addDeskToAcceptanceSetup';
import { useOpenCreateDeskModal } from '../../../controllers/SetDeskName';

const AddDeskOption = (props) => {
  const canAdd = useCanAddDesk();

  return canAdd ? <AddDeskToSetup {...props} /> : <CreateDeskName {...props} />;
};

export default AddDeskOption;

function AddDeskToSetup({ onClose, ...props }) {
  const addDesk = useAddDeskToAcceptanceSetup();

  const handleClick = () => {
    addDesk();
    onClose();
  };

  return <BaseOption {...props} onClick={handleClick} />;
}

function CreateDeskName({ onClose, ...props }) {
  const hasNames = useHasDeskNames();

  const openCreateDeskModal = useOpenCreateDeskModal();

  const handleClick = () => {
    Modal.confirm({
      title: hasNames ? 'Не осталось доступных столов' : 'Нет доступных столов',
      onOk: () => {
        openCreateDeskModal();
      },
      okText: 'Создать новый стол',
      onCancel: () => {},
    });

    onClose();
  };

  return <BaseOption {...props} onClick={handleClick} />;
}

function BaseOption(props) {
  return <Menu.Item {...props}>Добавить стол</Menu.Item>;
}
